export default {
    PvPgameTitle: "摘星星-游戏设置",
    gameTitle: "摘星星",
    topicLabel: "主题",
    correctItems: "答对题目",
    correctItemsPlaceholder: "输入正确词汇，用逗号(,)分隔，按下Enter新增项目",   
    errorItems: "答错题目",
    errorItemsPlaceholder: "输入错误词汇，用逗号(,)分隔，按下Enter新增项目",
    gameDuration: "游戏时长",
    second: "秒",
    saveSettings: "保存设置",
    startGame: "开始游戏",
    pauseGame: "暂停游戏",
    resumeGame: "继续游戏",
    gameOver: "游戏结束",
    leftSide: "左方",
    rightSide: "右方",
    leftWins: "左方获胜！",
    rightWins: "右方获胜！",
    tie: "平局！",
    playAgain: "再玩一次",
    wordExists: "词汇已存在，无需重复加入",
    maxVocabulary: "正确词汇已达最大值，请删减词汇再加入",
    maxErrorVocabulary: "错误词汇已达最大值，请删减词汇再加入",
    topic: "主题",
    inputTopic: "请输入主题",
    backgroundSetting: "背景设置",
    ocean: "海洋",
    desert: "沙漠",
    forest: "森林",
    gameSpeed: "游戏速度",
    speedSlow: "慢",
    speedMedium: "中",
    speedFast: "快",
    
    // 游戏结束画面新增字符串
    win: "胜利",
    items: "个",
    wrongItems: "答对题目",
    maxCombo: "最高连击",
    showAnswers: "A",
    gamePaused: "活动暂停",
    referenceAnswers: "参考答案",
    clearData: "清除数据",
    sendSuccess: "游戏资料已成功推送！",
    sendCooldown: "已按送出，请等候1分钟才可再操作",
    configLoadSuccess: "成功加载游戏配置",
    configLoadFailed: "加载失败（使用示例配置）",
}